import { ReactNode } from "react"

import { Box } from "@mui/material"
import ProcessingOverlay from "components/common/processingOverlay"
import { useTranslation } from "react-i18next"

interface IProps {
  deletingCount: number | null
  children: ReactNode
}

// While a background delete runs, the table is covered and taken out of the
// tab order; the toolbar above stays usable.
const TransactionsTableArea = ({ deletingCount, children }: IProps) => {
  const { t } = useTranslation()
  const isDeleting = deletingCount !== null

  return (
    <Box position="relative">
      <Box {...(isDeleting ? { inert: "" } : {})}>{children}</Box>
      {isDeleting && (
        <ProcessingOverlay
          isMessageSticky
          message={t("allTransactions.deletingTransactions", {
            count: deletingCount,
          })}
        />
      )}
    </Box>
  )
}

export default TransactionsTableArea
